import React,{useEffect} from 'react';
import { Link ,useNavigate} from 'react-router-dom';
import $ from "jquery";

const Header = () => {
  const navigate = useNavigate();

  const navigateToContract = () => {
    document.querySelector('.mobile_menu')?.classList.remove('open');
    document.querySelector('.hamburger')?.classList.remove('active');
    navigate("/contract");
  };
  useEffect(() => {
    $("a").on('click', function() {
      //      this.classList.toggle('active');
      const mobileMenu = document.querySelector('.mobile_menu');            
      mobileMenu.classList.toggle('open');
      const mobileMenuButton = document.querySelector('.hamburger'); 
      mobileMenuButton.classList.toggle('active'); // 햄버거 애니메이션용   
  
      // aria-expanded 업데이트도 함께 해줌
      // const isExpanded = this.getAttribute('aria-expanded') === 'true';
      // this.setAttribute('aria-expanded', String(!isExpanded));
    });    
  }, []); // Empty dependency array ensures this runs only once after initial render
  
  

  const toggleAccordion = (event) => {  

      const content = event.currentTarget.nextElementSibling;  
      const arrow = event.currentTarget.querySelector(".arrow");
      
      content.classList.toggle("active");
      arrow.classList.toggle("rotated");
  };
  
  return (
    <div className="header">
        <div className="container header_inner">
          {/* <!-- 로고 --> */}
          <div className="logo">
            <a href="/">
              <img src='/assets/images/logo.png' alt='드림티원 로고'/>
            </a>
          </div>
          {/* <!-- PC용 네비게이션 + 무료체험 버튼 묶음 --> */}
          <nav className="main_nav" aria-label="메인 메뉴">
            <ul className="main_menu">
              <li><Link to="/about">회사 소개</Link></li>
              <li><Link to="/business">사업영역</Link></li>
              <li><Link to="/solutions">솔루션</Link></li>
              <li><Link to="/service">서비스</Link></li>
              <li><Link to="/support">고객지원</Link></li>
            </ul>
            <button className="free_btn" onClick={navigateToContract}>무료체험하기</button>
          </nav>
          {/* <!-- 모바일용 햄버거 버튼 --> */}
          <button className="hamburger" aria-label="메뉴 열기" aria-expanded="false">
            <span></span>
            <span></span>
            <span></span>
          </button>
          {/* <!-- 모바일용 메뉴 --> */}
          <nav className="mobile_menu" aria-label="모바일 메뉴">
            <div className="free_box">
              <p>"출입부터 급여까지, 모든 인사 프로세스를 자동화하세요."</p>
              <button className="free_btn" onClick={navigateToContract}>무료체험하기</button>
            </div>
            <div className="mobile_menu_list">
              {/* <!--아코디언--> */}
              <section className="mobile_menu_area">
                <div className="container">
                  <div className="accordion">
                    <div className="accordion-item">
                      <div className="accordion-header" onClick={toggleAccordion}>
                        <div className="aco_tit">회사 소개</div>
                        <div className="arrow"><img src="/assets/images/btn_arrow.png" alt="메인이미지"/></div>
                      </div>
                      <div className="accordion-content">
                        <div className="aco_con">
                          <ul>
                            <li><a href="/about#about_his">연혁 및 수상</a></li>
                            <li><a href="/about#about_vis">비전 및 미션</a></li>
                            <li><a href="/about#about_pat">고객사 및 파트너</a></li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <div className="accordion-header" onClick={toggleAccordion}>
                        <div className="aco_tit">사업영역</div>
                        <div className="arrow"><img src="/assets/images/btn_arrow.png" alt="메인이미지"/></div>
                      </div>
                      <div className="accordion-content">
                        <div className="aco_con">
                          <ul>
                            <li><a href="/business#bsn_circul">유통</a></li>
                            <li><a href="/business#bsn_medical">의료</a></li>
                            <li><a href="/business#bsn_edu">교육</a></li>
                            <li><a href="/business#bsn_erect">건설</a></li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <div className="accordion-header" onClick={toggleAccordion}>
                        <div className="aco_tit">솔루션</div>
                        <div className="arrow"><img src="/assets/images/btn_arrow.png" alt="메인이미지"/></div>
                      </div>
                      <div className="accordion-content">
                        <div className="aco_con">
                          <ul>
                            <li><a href="/solutions#sol_access">출입 통제</a></li>
                            <li><a href="/solutions#sol_adult">성인인증</a></li>
                            <li><a href="/solutions#sol_kiosk">스마트 키오스크</a></li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <div className="accordion-header" onClick={toggleAccordion}>
                        <div className="aco_tit">서비스</div>
                        <div className="arrow"><img src="/assets/images/btn_arrow.png" alt="메인이미지"/></div>
                      </div>
                      <div className="accordion-content">
                        <div className="aco_con">
                          <ul>
                            <li><a href="/service#ser_manage">일용직 근태관리</a></li>
                            <li><a href="/service#ser_stu">학원생 출결관리</a></li>
                            <li><a href="/service#ser_api">얼굴인식 API</a></li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <div className="accordion-header" onClick={toggleAccordion}>
                        <div className="aco_tit">고객지원</div>
                        <div className="arrow"><img src="/assets/images/btn_arrow.png" alt="메인이미지"/></div>
                      </div>
                      <div className="accordion-content">
                        <div className="aco_con">
                          <ul>
                            <li><a href="/support" className="active">FAQ</a></li>
                            <li><a href="/notice">공지사항</a></li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>  
              </section>
            
            </div>
          </nav>
        </div>
      </div>
  );
};

export default Header;